import React from 'react';
import {ViewStyle} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useClientsOverviewSection} from './ClientsOverviewSection.hook';
import {getListItems} from './ClientsOverviewSection.util';

interface ClientsOverviewSectionProps {
  currentUserCompetency: string;
  newClientsCountFrontline: number | null;
  newClientsCountGen0: number | null;
  newClientsCountOrg: number | null;
  clientsCountFrontline: number | null;
  clientsCountGen0: number | null;
  clientsCountOrg: number | null;
  onShowInfoPopover: () => void;
  onShowReport: () => void;
  // eslint-disable-next-line react/require-default-props
  style?: ViewStyle;
}

export const ClientsOverviewSection = ({
  currentUserCompetency = '',
  newClientsCountFrontline = null,
  newClientsCountGen0 = null,
  newClientsCountOrg = null,
  clientsCountFrontline = null,
  clientsCountGen0 = null,
  clientsCountOrg = null,
  onShowInfoPopover = () => {},
  onShowReport = () => {},
  style = {},
}: ClientsOverviewSectionProps) => {
  const {onInfoPress, onItemPress, tt, ts} = useClientsOverviewSection({
    onShowInfoPopover,
    onShowReport,
  });
  const listItems = getListItems({
    clientsCountFrontline,
    clientsCountGen0,
    clientsCountOrg,
    currentUserCompetency,
    newClientsCountFrontline,
    newClientsCountGen0,
    newClientsCountOrg,
    tt,
  });
  return (
    <MetricSection
      analyticsTitle="Clients Overview"
      testID={MetricsSection.metricSectionClientsOverview}
      title={tt('heading', 'Clients Overview')}
      containerStyle={style}
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Clients Section Information button',
      )}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
    />
  );
};

export default ClientsOverviewSection;
